import React from "react"
import { motion } from "framer-motion"
import Layout from "../components/layout"
import "../css/about.css"

import breaker from "../images/about-1.png"
import me from "../images/me.jpg"

const About = () => {
  return (
    <Layout seo="About">
      <section className="about-head">
        <motion.svg
          initial={{ y: -200 }}
          animate={{ y: 0 }}
          transition={{ duration: 1, ease: [0.3, -0.05, 0.01, 0.9] }}
          className="about-headlogo"
          xmlns="http://www.w3.org/2000/svg"
          width="22.35rem"
          viewBox="0 0 487.95 114.01"
        >
          <title>Horizon Logotype</title>
          <path
            d="M184.62,47.46a1,1,0,0,1,1-1h32.69q11.31,0,18.71,7.24a23.9,23.9,0,0,1,7.4,17.75A25.14,25.14,0,0,1,243,80a22.6,22.6,0,0,1-3.37,6.42,30.26,30.26,0,0,1-4,4.19A14.68,14.68,0,0,1,232.22,93l-.49.27a1,1,0,0,0-.4,1.36l15,26.44a1,1,0,0,1-.87,1.49H230.31a1,1,0,0,1-.87-.52l-14.08-25.6a1,1,0,0,0-.87-.52H202a1,1,0,0,0-1,1v24.65a1,1,0,0,1-1,1H185.62a1,1,0,0,1-1-1Zm40.57,16.63a10.09,10.09,0,0,0-7.41-2.92H202a1,1,0,0,0-1,1V80.28a1,1,0,0,0,1,1h15.82a10.27,10.27,0,0,0,7.41-2.84,9.32,9.32,0,0,0,2.94-7A9.94,9.94,0,0,0,225.19,64.09Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M262.78,46.47h14.36a1,1,0,0,1,1,1v74.1a1,1,0,0,1-1,1H262.78a1,1,0,0,1-1-1V47.46A1,1,0,0,1,262.78,46.47Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M294.91,60.18V47.46a1,1,0,0,1,1-1H351a1,1,0,0,1,1,1V60.81a1,1,0,0,1-.23.63l-37,44.85a1,1,0,0,0,.76,1.62h36.59a1,1,0,0,1,1,1v12.66a1,1,0,0,1-1,1H294.25a1,1,0,0,1-1-1V108.27a1,1,0,0,1,.23-.63l37-44.85a1,1,0,0,0-.76-1.62H295.9A1,1,0,0,1,294.91,60.18Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M373.69,56.5q12-11.62,29.34-11.62T432.37,56.5a37.65,37.65,0,0,1,12,28,37.73,37.73,0,0,1-12,28Q420.4,124.2,403,124.2t-29.34-11.65a37.7,37.7,0,0,1-12-28A37.62,37.62,0,0,1,373.69,56.5Zm12,45.79a24.42,24.42,0,0,0,34.65,0,24.31,24.31,0,0,0,7.11-17.75,24.39,24.39,0,0,0-7.11-17.77,24.33,24.33,0,0,0-34.65,0,24.39,24.39,0,0,0-7.11,17.77A24.31,24.31,0,0,0,385.7,102.29Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M527.44,47.46v74.1a1,1,0,0,1-1,1H513.81a1,1,0,0,1-.78-.39L477.65,76.51a1,1,0,0,0-1.78.61v44.44a1,1,0,0,1-1,1H460.52a1,1,0,0,1-1-1V47.46a1,1,0,0,1,1-1h12.69a1,1,0,0,1,.78.39l35.39,45.7a1,1,0,0,0,1.77-.6V47.46a1,1,0,0,1,1-1h14.31A1,1,0,0,1,527.44,47.46Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M104.11,139.41V29.67a2.14,2.14,0,0,1,4.27,0V139.41a2.14,2.14,0,0,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M113.26,120.05a2.33,2.33,0,0,1,.12-.73,2.15,2.15,0,0,1,2.74-1.28,35.67,35.67,0,1,0,0-67,2.14,2.14,0,0,1-1.46-4,39.93,39.93,0,1,1,0,75A2.15,2.15,0,0,1,113.26,120.05Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M113.26,108.08a2.13,2.13,0,0,1,3.15-1.87,24.69,24.69,0,1,0,0-43.35,2.13,2.13,0,1,1-2-3.74,29,29,0,1,1,0,50.84A2.14,2.14,0,0,1,113.26,108.08Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M95,96.73V72.35a2.14,2.14,0,1,1,4.27,0V96.73a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M85.82,113.8V55.28a2.14,2.14,0,1,1,4.27,0V113.8a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M76.68,119.9V49.18a2.13,2.13,0,1,1,4.26,0V119.9a2.13,2.13,0,0,1-4.26,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M67.53,106.49V62.59a2.14,2.14,0,0,1,4.27,0v43.9a2.14,2.14,0,0,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M58.39,90.64V78.44a2.13,2.13,0,0,1,4.26,0v12.2a2.13,2.13,0,1,1-4.26,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M49.24,110.14V58.93a2.14,2.14,0,0,1,4.27,0v51.21a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
          <path
            d="M39.49,86.06V83a2.14,2.14,0,0,1,4.27,0v3a2.14,2.14,0,1,1-4.27,0Z"
            transform="translate(-39.49 -27.54)"
          />
        </motion.svg>
        <div>
          <motion.h2
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{
              delay: 0.65,
              duration: 1.5,
              ease: [0.3, -0.05, 0.01, 0.9],
            }}
          >
            Striving to push experimental designs to new Horizons
          </motion.h2>
          <motion.p
            initial={{ y: 200, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              delay: 2.2,
              duration: 0.5,
              ease: [0.3, -0.05, 0.01, 0.9],
            }}
          >
            By{" "}
            <u>
              <i>experimental</i>
            </u>
            , it also means <i>exploratory</i>. An outlet to attempt and explore
            new things.
          </motion.p>
          <motion.p
            initial={{ y: 200, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              delay: 3.2,
              duration: 0.5,
              ease: [0.3, -0.05, 0.01, 0.9],
            }}
          >
            Horizon Designs is a personal brand project.
          </motion.p>
        </div>
      </section>

      <section className="about-story">
        <div className="story-text">
          <h2>The Story</h2>
          <p>
            Circa 2019, there was a keyboard concept that I really wanted to
            experiment with. This soon snowballed into my motivation to make a
            keyboard personalized for myself; and when I say personalized, I
            mean everything from the ground-up rather than a commissioned design
            (commissions weren't popularized until late 2021).
            <br />
            <br />
            Throughout the years of dabbling in keyboards as a hobby, I made
            some great friends that made keyboards just as enjoyable, and one of
            them was willing to give me a hand with my project. As we worked on
            the project, it became more and more apparent that keyboards
            required an identity as part of the current keyboard culture.
            <br />
            <br />
            Evidently, this also snowballed my desire to brand myself. I figured
            it was time for me to give it a try. I am confident that this will
            provide me with valuable lessons, and I hope to purpose Horizon
            Designs for all things to come as I continue to dabble in more
            hobbies in the future.
          </p>
        </div>
        <img alt="word breaker" src={breaker} />
      </section>

      <section className="about-me">
        <div className="me-container">
          <img className="me-portrait" alt="portrait" src={me} />
          <div className="me-text">
            <h2>Hi, I'm Howard.</h2>
            <p>
              My name is Howard Kim (Ho Kim, 김호, 金瑚), and I am a 1.5
              <sup>th </sup>
              generation Korean-American located in San Francisco Bay Area,
              California.
              <br />
              <br />
              I am a graduate of University of California, San Diego (UCSD) with
              a Bachelor of Science degree in Cognitive Science with
              Specialization to Machine Learning & Neural Computation. I have
              also studied Computer Science and Human-Computer Interaction (or
              also known as Design & Interaction), which focuses on design
              lifecycles and UI/UX frontend development.
              <br />
              <br />
              After being graduated, I am working as a Full Stack Software
              Engineer in the Bay Area. With a passion for automation, data, and
              design (both physical & digital), I am focused on engineering and
              building products that are high in quality, scalability, and
              performance.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default About
